import React, { useEffect, useState } from "react";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import { Table } from "antd";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import "./styles/personalfamilyInformation.css";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DropdownWithButton from "../../components/Dropdown/DropdownWithButton";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useFetchItems from "../../hooks/useFetchItems";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import { getAllColumns } from "./columnsData";
import useDeleteItem from "../../hooks/useDeleteItem";
import useModalHandlers from "../../hooks/useModalHandler";
import useFetchContacts from "../../hooks/useFetchContacts";
import useChangeHandler from "../../hooks/useChangeHandler";

const moduleNames = [
  "Personal and Family Information",
  "School Name",
  "Pet Information",
  "Workplace/Employer Name",
];
export default function PersonalFamilyInformation() {
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Personal and Family Information");
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attributesData, setAttributesData] = useState(null);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(moduleNames, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { contactList } = useFetchContacts(setLoading);
  const { attributes, disasterAttribute } = useGetAttributes(moduleNames, setLoading);

  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const history = useHistory();

  const tableDataObj = {
    "Personal and Family Information": tableData.personalAndFamilyInformationData,
    "School Name": tableData.schoolNameData,
    "Pet Information": tableData.petInformationData,
    "Workplace/Employer Name": tableData.workplaceEmployerNameData,
  };

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  console.log("formdataaa", formData);
  const collapseableTables = [
    { title: "Household Members", key: 1 },
    { title: "Primary Doctor Contact Information", key: 2 },
    { title: "Pediatrician Contact Information", key: 3 },
    { title: "Pet Information", key: 4 },
  ];
  const workplaceTables = [
    { title: "School Name", key: 5 },
    { title: "Workplace/Employer Name", key: 6 },
    { title: "Out-of-State contact person", key: 7 },
  ];
  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/orgainzer/important-document");
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  // const handleItemsInfoSelect = (name, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
        <h2 className="parent-title">Personal & Family Information</h2>
        <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div>
      </div>
      {collapseableTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() => (table.title === "Pet Information" ? showModal(table.title) : AddContact())}
          options={contactList}
        >
          <Table columns={AllColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>

      <div className="child-title-container">
        <h2 className="child-title">Veterinary Records</h2>
      </div>
      <DropdownWithButton placeholder={""} options={[]} OnClick={AddDocument} />
      {workplaceTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() =>
            table.title === "Out-of-State contact person" ? AddContact() : showModal(table.title)
          }
          showDropDown={table.key === 7 && true}
        >
          <Table columns={AllColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
          <NewLoader isLoading={loading} />
        </CollapseableTable>
      ))}
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute && disasterAttribute}
            values={disasterAttributeData && disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}

      <NewLoader isLoading={loading} />
    </div>
  );
}
